// frontend/src/services/cardService.js
import api from './apiService';

// Contas (Mantido para compatibilidade)
export const getContas = async () => {
    const response = await api.get('financeiro/contas/');
    return response.data;
};

// ===================================================================================
//  SERVIÇOS DO MÓDULO DE CARTÃO DE CRÉDITO
// ===================================================================================

// --- Gestão de Cartões Principais ---
export const getCartoes = async (params = {}) => {
    const response = await api.get('financeiro/cartoes/', { params });
    return response.data;
};

export const createCartao = async (cartaoData) => {
    const response = await api.post('financeiro/cartoes/', cartaoData);
    return response.data;
};

export const updateCartao = async (id, cartaoData) => {
    const response = await api.put(`financeiro/cartoes/${id}/`, cartaoData);
    return response.data;
};

export const deleteCartao = async (id) => {
    const response = await api.delete(`financeiro/cartoes/${id}/`);
    return {
        data: response.data,
        archived: response.status === 200,
    };
};

// ===================================================================================
// INÍCIO DA ALTERAÇÃO: Novas funções de arquivamento para Cartão de Crédito
// ===================================================================================
export const arquivarCartao = async (id) => {
    const response = await api.post(`financeiro/cartoes/${id}/arquivar/`);
    return response.data;
};

export const reativarCartao = async (id) => {
    const response = await api.post(`financeiro/cartoes/${id}/reativar/`);
    return response.data;
};
// ===================================================================================
// FIM DA ALTERAÇÃO
// ===================================================================================


// --- Gestão de Faturas ---
export const getFaturaDetail = async (cartaoId, ano, mes) => {
    const response = await api.get(`financeiro/cartoes/${cartaoId}/faturas/${ano}/${mes}/`);
    return response.data;
};

export const getFaturaContextoInicial = async (cartaoId) => {
    const response = await api.get(`financeiro/cartoes/${cartaoId}/contexto-inicial/`);
    return response.data;
};

export const getFaturasDisponiveis = async (cartaoId, faturaContextoId) => {
    const config = faturaContextoId ? { params: { fatura_contexto_id: faturaContextoId } } : {};
    const response = await api.get(`financeiro/faturas/disponiveis/cartao/${cartaoId}/`, config);
    return response.data;
};

export const getProximasFaturas = async () => {
    const response = await api.get('financeiro/faturas/proximas/');
    return response.data;
};

export const pagarFatura = async (faturaId, payload) => {
    const response = await api.post(`financeiro/faturas/${faturaId}/pagar/`, payload);
    return response.data;
}

export const reabrirFatura = async (faturaId) => {
    const response = await api.post(`financeiro/faturas/${faturaId}/reabrir/`);
    return response.data;
};


// --- Gestão de Lançamentos na Fatura ---
export const createTransacaoFatura = async (payload) => {
    const response = await api.post('financeiro/transacoes/', payload);
    return response.data;
};

export const createCompraParcelada = async (payload) => {
    const response = await api.post('financeiro/compras-parceladas/', payload);
    return response.data;
};

export const createEstorno = async (payload) => {
    const response = await api.post('financeiro/estornos/', payload);
    return response.data;
};

export const createEncargoFatura = async (payload) => {
    const response = await api.post('financeiro/encargos/', payload);
    return response.data;
}

export const updateEncargoFatura = async (transacaoId, payload) => {
    const response = await api.put(`financeiro/encargos/${transacaoId}/`, payload);
    return response.data;
}

export const createPagamentoParcial = async (payload) => {
    const response = await api.post('financeiro/pagamentos-parciais/', payload);
    return response.data;
};

export const updatePagamentoParcial = async (transacaoId, payload) => {
    const response = await api.put(`financeiro/pagamentos-parciais/${transacaoId}/`, payload);
    return response.data;
};

export const deleteTransacaoFatura = async (transacaoId, scope = null) => {
    const config = scope ? { params: { escopo: scope } } : {};
    const response = await api.delete(`financeiro/transacoes/${transacaoId}/`, config);
    return response.data;
};

export const deletePagamentoParcial = async (pagamentoId) => {
    const response = await api.delete(`financeiro/pagamentos-parciais/${pagamentoId}/`);
    return response.data;
};


// --- Gestão de Cartões Adicionais ---
export const getCartoesAdicionais = async (cartaoPrincipalId, status = null) => {
    const config = status ? { params: { status } } : {};
    const response = await api.get(`financeiro/cartoes/${cartaoPrincipalId}/adicionais/`, config);
    return response.data;
};

export const createCartaoAdicional = async (data) => {
    const response = await api.post('financeiro/cartoes-adicionais/', data);
    return response.data;
};

export const updateCartaoAdicional = async (id, data) => {
    const response = await api.put(`financeiro/cartoes-adicionais/${id}/`, data);
    return response.data;
};

export const deleteCartaoAdicional = async (id) => {
    return await api.delete(`financeiro/cartoes-adicionais/${id}/`);
};

export const reactivateCartaoAdicional = async (id) => {
    const response = await api.post(`financeiro/cartoes-adicionais/${id}/reativar/`);
    return response.data;
};


// --- Lógica de Negócio Específica ---
export const getGastosPortadorFatura = async (faturaId) => {
    const response = await api.get(`financeiro/faturas/${faturaId}/gastos-portador/`);
    return response.data;
};

export const gerarContaReceber = async (payload) => {
    const response = await api.post('financeiro/contas-a-receber/gerar/', payload);
    return response.data;
};

export const getCotacaoUsdBrl = async (data = null) => {
    const params = data ? { data } : {};
    const response = await api.get('financeiro/cotacoes/usd-brl/', { params });
    return response.data;
};


// --- Análise de uso do cartão (gráficos) ---
export const getCartaoUsoPorDia = async ({ startDate, endDate, cartoes } = {}) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (cartoes?.length) params.cartoes = cartoes.join(',');
    const response = await api.get('financeiro/cartoes/uso-por-dia/', { params });
    return response.data;
};

export const getCartaoParcelamentosFuturos = async ({ cartoes, meses } = {}) => {
    const params = {};
    if (cartoes?.length) params.cartoes = cartoes.join(',');
    if (meses) params.meses = meses;
    const response = await api.get('financeiro/cartoes/parcelamentos-futuros/', { params });
    return response.data;
};
